import { Ng2StateDeclaration } from '@uirouter/angular';
import { FiAuthenticateLoginHelpComponent } from '@fi-app/authenticate/login-help/login-help.component';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export const FiAuthStatesLoginLoginHelpState: Ng2StateDeclaration = {
    name: FiStateNames.Login.LoginHelp,
    url: '/Help',
    component: FiAuthenticateLoginHelpComponent,
    resolve: {
        pageTitle: [PageTitleService, FiAuthStatesLoginLoginHelpResolve_pageTitle_resolveFunc],
    },
};

export function FiAuthStatesLoginLoginHelpResolve_pageTitle_resolveFunc(pageTitleService: PageTitleService) {
    return pageTitleService.setTitle('Login Help');
}
